import type { FormLabelProps } from "@mui/material/FormLabel";
import MuiFormLabel, { formLabelClasses } from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import { FontSize } from "src/const/font";
import { theme } from "src/theme";
import { colors } from "../../colors/colors";

interface LabelProps extends FormLabelProps {
  title: string;
  name: string;
  required?: boolean;
  gutterBottom?: boolean;
}

const FormLabel = (props: LabelProps) => {
  const { title, name, required, gutterBottom, ...rest } = props;
  return (
    <MuiFormLabel
      sx={{
        display: "block",
        mb: gutterBottom ? "0.35em" : 0,
        [`& .${formLabelClasses.asterisk}`]: {
          color: "red",
          lineHeight: "20px",
        },
        [theme.breakpoints.up("md")]: {
          fontSize: FontSize.normal.default,
          marginBottom: "12px",

        },
        [theme.breakpoints.down("md")]: {
          fontSize: FontSize.normal.p4,
          marginBottom: "4px",
        },
        color: colors.text.main,
      }}
      htmlFor={name}
      required={required}
      {...rest}
    >
      {title}
    </MuiFormLabel>
  );
};

export default FormLabel;
